import React, { useState, useEffect } from "react";

import { connect } from "react-redux";

import {
	Flashcard,
	CircleButton,
	Text,
	SmallInstructionText,
	SettingsContainer,
	BottomButton,
} from "./flashcards.styles";
import RoundedContainerWithBG from "../../components/rounded-container-with-bg/rounded-container-with-bg.component";
import { removeFormilla, addFormilla } from "../../utils/formilla.utils";
import { useRouteMatch } from "react-router-dom";
import { selectFlashcards } from "../../redux/flashcards/flashcards.selectors";
import {
	getFlashcardsStart,
	resetFlashcards_Action,
} from "../../redux/flashcards/flashcards.actions";
import { selectIsLoggedIn } from "../../redux/current-user/current-user.selector";
import { hideAlertAction } from "../../redux/alert/alert.actions";
import {
	setOverflowHiddenOnBody,
	unsetOverflowHiddenOnBody,
} from "../../utils/css.utils";

const FlipDirection = direction => {
	if (direction === "") {
		return "-";
	} else {
		return "";
	}
};

//var YRotation = 0;

const FlashcardsPage = ({
	flashcards,
	getFlashcards,
	isLoggedIn,
	hidePossibleAlerts,
	resetFlashcards,
}) => {
	const SwissGerman = 0;
	const English = 1;
	const [startWithEnglish, togglStartWithEnglish] = useState(false);
	const [shouldFlashcardsrefresh, setshouldFlashcardsRefresh] =
		useState(false);
	const [YRotation, setYRotation] = useState(0);
	var languages = ["SwissGerman", "English"];
	const VideoID = useRouteMatch().params["VideoID"];
	const [currentFlashcardNumber, setCurrentFlashcardNumber] = useState(0);
	var [currentLanguage, setCurrentLanguage] = useState(0);
	const transitionDuration = 700;
	var roundedContainer = document.getElementById("rounded-container");
	var AdjustingYRotationContainer = document.getElementById(
		"adjusting-yrotation-container"
	);
	var originalRotation = "";

	const getElementsAndAddTransitionDuration = () => {
		roundedContainer = document.getElementById("rounded-container");
		AdjustingYRotationContainer = document.getElementById(
			"adjusting-yrotation-container"
		);
		AdjustingYRotationContainer.style.transform = `rotateY(${0}deg) translateZ(${0}1px)`;
		roundedContainer.style.transitionDuration = `${transitionDuration}ms`;
	};

	useEffect(() => {
		hidePossibleAlerts();
		getFlashcards(VideoID);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoggedIn]);

	useEffect(() => {
		removeFormilla();
		getElementsAndAddTransitionDuration();
		setOverflowHiddenOnBody();

		return () => {
			unsetOverflowHiddenOnBody();
			addFormilla();
			resetFlashcards();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		UpdateCurrentLanguage();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [startWithEnglish]);

	function TogglRefreshFlashcard() {
		setshouldFlashcardsRefresh(!shouldFlashcardsrefresh);
	}

	function UpdateCurrentLanguage() {
		if (startWithEnglish) {
			setCurrentLanguage(English);
		} else {
			setCurrentLanguage(SwissGerman);
		}
	}

	const rotate180 = () => {
		var zPriority = "";

		const newYRoatation = YRotation + 180;
		setYRotation(newYRoatation);
		roundedContainer.style.transform = `rotateY(${newYRoatation}deg)`;

		setTimeout(() => {
			if (newYRoatation % 360 === 0) {
				zPriority = "";
			} else {
				zPriority = "-";
			}
			AdjustingYRotationContainer.style.transform = `rotateY(${newYRoatation}deg) translateZ(${zPriority}1px)`;
			setCurrentLanguage((currentLanguage + 1) % 2);
		}, transitionDuration / 3.5);
	};

	const SlideOutFlashcard = direction => {
		var directionChanger = "";
		if (direction === "toLeft") directionChanger = "-";
		if (YRotation % 360 !== 0) {
			directionChanger = FlipDirection(directionChanger);
		}
		originalRotation = roundedContainer.style.transform;
		roundedContainer.style.transform =
			originalRotation + ` translateX(${directionChanger}100vw)`;
	};

	const SlideInFlashcard = direction => {
		var directionChanger = "";
		if (direction === "fromLeft") directionChanger = "-";
		if (YRotation % 360 !== 0) {
			directionChanger = FlipDirection(directionChanger);
		}
		roundedContainer.style.display = "none";
		roundedContainer.style.transitionDuration = "0s";
		roundedContainer.style.transform =
			originalRotation + `translate(${directionChanger}100vw)`;
		roundedContainer.style.display = "block";

		setTimeout(() => {
			roundedContainer.style.transitionDuration = `${transitionDuration}ms`;
			roundedContainer.style.transform = originalRotation;
		}, 50);
	};
	function changeCurrentLanguageToDeafult() {
		if (startWithEnglish && languages[currentLanguage] === "SwissGerman") {
			setCurrentLanguage((currentLanguage + 1) % 2);
		}
		if (!startWithEnglish && languages[currentLanguage] === "English") {
			setCurrentLanguage((currentLanguage + 1) % 2);
		}
	}

	const NextFlashcard = event => {
		event.stopPropagation();
		SlideOutFlashcard("toRight");
		setTimeout(() => {
			changeCurrentLanguageToDeafult();
			setCurrentFlashcardNumber(
				(currentFlashcardNumber + 1) % flashcards.length
			);
			SlideInFlashcard("fromLeft");
		}, transitionDuration);
	};

	const PreviousFlashcard = event => {
		event.stopPropagation();
		SlideOutFlashcard("toLeft");
		setTimeout(() => {
			setCurrentFlashcardNumber(
				(currentFlashcardNumber - 1) % flashcards.length
			);
			SlideInFlashcard("fromRight");
		}, transitionDuration);
	};

	return (
		<div>
			<SettingsContainer>
				<input
					type="checkbox"
					onClick={() => {
						togglStartWithEnglish(!startWithEnglish);
					}}
				/>
				start with English
				{currentFlashcardNumber === flashcards.length - 1 ? (
					<button
						onClick={() => {
							setCurrentFlashcardNumber(0);
							UpdateCurrentLanguage();
							getFlashcards(VideoID);
						}}
					>
						restart
					</button>
				) : null}
			</SettingsContainer>

			<RoundedContainerWithBG padding="0px">
				<div id={"adjusting-yrotation-container"}>
					{shouldFlashcardsrefresh}
					<SmallInstructionText>tap to flip</SmallInstructionText>
					<Flashcard onClick={rotate180}>
						{currentFlashcardNumber !== 0 ? (
							<CircleButton
								onClick={PreviousFlashcard}
								style={{ marginLeft: "0px" }}
							>
								{"<"}
							</CircleButton>
						) : null}
						<Text $currentLanguage={currentLanguage}>
							{
								flashcards[currentFlashcardNumber][
									languages[currentLanguage]
								]
							}
						</Text>
						{currentFlashcardNumber !== flashcards.length - 1 ? (
							<CircleButton
								onClick={NextFlashcard}
								$top={"5.25px"}
								$left={"-0.5px"}
								style={{ marginRight: "0px" }}
							>
								{" > "}
							</CircleButton>
						) : null}
					</Flashcard>
					<BottomButton
						onClick={e => {
							e.stopPropagation();
							if (flashcards.length === 1) {
								flashcards[0] = {
									English: "you finished",
									SwissGerman: "Congratulations",
									index: 0,
								};
								TogglRefreshFlashcard();
								setCurrentLanguage(SwissGerman);
								togglStartWithEnglish(false);
							} else {
								SlideOutFlashcard("toRight");
								setTimeout(() => {
									changeCurrentLanguageToDeafult();

									setCurrentFlashcardNumber(
										currentFlashcardNumber ===
											flashcards.length - 1
											? currentFlashcardNumber - 1
											: currentFlashcardNumber
									);
									flashcards.splice(
										currentFlashcardNumber,
										1
									);
									TogglRefreshFlashcard();
									SlideInFlashcard("fromLeft");
								}, transitionDuration);
							}
						}}
					>
						learned
					</BottomButton>
				</div>
			</RoundedContainerWithBG>
		</div>
	);
};

const mapStateToProps = state => ({
	flashcards: selectFlashcards(state),
	isLoggedIn: selectIsLoggedIn(state),
});

const mapDispatchToProps = dispatch => ({
	getFlashcards: videoID => dispatch(getFlashcardsStart(videoID)),
	hidePossibleAlerts: () => dispatch(hideAlertAction()),
	resetFlashcards: () => dispatch(resetFlashcards_Action()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FlashcardsPage);

/*<AdjustingYRotationContainer id={"adjusting-yrotation-container"}>
				<button onClick={rotate90}>rotate</button>
				<button onCLick={NextFlashcard}> {">"} </button>
				{/*flashcards[currentFlashcard][currentLanguage]*/
//</AdjustingYRotationContainer>
